import moment from "moment";
import { MdKey, MdKeyOff, MdNorth, MdNorthEast, MdEast, MdSouthEast, MdSouth, MdSouthWest, MdWest, MdNorthWest, MdOutlineSatelliteAlt } from "react-icons/md";
import { RiMapPinTimeFill } from "react-icons/ri";
import { SiGitconnected } from "react-icons/si";
import { Button, Card, ListGroup } from 'react-bootstrap';
import { FaLock, FaLockOpen, FaMapMarkedAlt, FaCarBattery, FaRunning, FaRegStopCircle } from "react-icons/fa";
import { PiBellSimpleRingingFill } from 'react-icons/pi';
import { TbEngineOff, TbClockExclamation } from "react-icons/tb";
import { FaPencil } from "react-icons/fa6";

// eslint-disable-next-line
const VehicleCard = ({ vehicleData, OpenLastPositions, fusoUser, OpenMap, handleOpenModalBlock, showEditingHodo, showEditingNotification }) => {
    const windDirections = [
        { name: "Norte", range: [326.25, 33.75], icon: MdNorth },
        { name: "Nordeste", range: [33.75, 78.75], icon: MdNorthEast },
        { name: "Leste", range: [78.75, 123.75], icon: MdEast },
        { name: "Sudeste", range: [123.75, 168.75], icon: MdSouthEast },
        { name: "Sul", range: [168.75, 213.75], icon: MdSouth },
        { name: "Sudoeste", range: [213.75, 258.75], icon: MdSouthWest },
        { name: "Oeste", range: [258.75, 303.75], icon: MdWest },
        { name: "Noroeste", range: [303.75, 326.25], icon: MdNorthWest },
    ];
    const WindIndicatorName = (crs) => {
        const direction = getWindDirection(crs);
        return direction ? direction?.name : 'NORTE';
    };

    const WindIndicator = ({ crs }) => {
        const direction = getWindDirection(crs);
        const IconComponent = direction ? direction?.icon : MdNorth; // Pegue o componente do ícone
        return (
            <IconComponent className="icon-btn-edit-notification" />
        );
    };

    const getWindDirection = (crs) => {
        for (const direction of windDirections) {
            const [min, max] = direction.range;
            // Verifica se está no intervalo (inclui tratamento para o intervalo de 348.75 a 11.25)
            if (
                (min > max && (crs >= min || crs < max)) || // Exceção para N (348.75 a 11.25)
                (crs >= min && crs < max)
            ) {
                return direction;
            }
        }
    };
    const aliveServer = moment.utc(vehicleData.alive).utcOffset(60);
    const dateServer = moment(); // Data e hora atuais
    const courseName = WindIndicatorName(vehicleData.course)

    const differenceInMinutes = dateServer.diff(aliveServer, 'minutes');
    const alive = differenceInMinutes <= 30;
    var hodo = String(vehicleData.odometer).substring(0, 6).replace(".", "")
    hodo = hodo.replace(/(\d+)(\d{3})$/, '$1.$2');

    return (
        <Card className="card-list">
            <Card.Body>
                <Card.Title className="card-title">
                    <Button className="btn-edit-notification" onClick={() => showEditingNotification(vehicleData.idVehicle)}>
                        <PiBellSimpleRingingFill className="icon-btn-edit-notification" />
                    </Button>
                    <p className="text-p">{vehicleData.plate}</p>
                    <Button
                        className="btn-edit-home"
                    // onClick={() => showEditing(vehicleData)}
                    >
                        <FaPencil className="icon-btn-edit-home" />
                    </Button>
                </Card.Title>
                <ListGroup variant="flush">
                    <ListGroup.Item className="list-item"><strong className="strong-list">Desc:</strong> {vehicleData.description}</ListGroup.Item>

                    <ListGroup.Item className="list-item"><strong className="strong-list">Loc:</strong> {vehicleData.nearDesc} </ListGroup.Item>

                    <ListGroup.Item title={courseName} className="list-item">
                        <strong className="strong-list">Direct: </strong>
                        <WindIndicator crs={vehicleData.course} />
                    </ListGroup.Item>

                    <ListGroup.Item className="list-item"><strong className="strong-list">Time:</strong> {`${moment(vehicleData.dateTime).subtract(Math.abs(fusoUser), "hours").format("DD/MM/yyyy")} - ${moment(vehicleData.dateTime).subtract(Math.abs(fusoUser), "hours").format("HH:mm:ss")}`}</ListGroup.Item>

                    <ListGroup.Item className="list-item">
                        <strong className="strong-list">Hodo:</strong> {hodo} km
                        {vehicleData.type !== "NEW" &&
                            <Button className="btn-edit-hodo-home" onClick={() => showEditingHodo(hodo, vehicleData)}>
                                <FaPencil className="icon-btn-edit-home" />
                            </Button>
                        }
                    </ListGroup.Item>
                    <ListGroup.Item className="list-item">
                        <strong className="strong-list">Vel:</strong> {vehicleData?.speed?.toFixed(0)} km/h
                        <strong style={{ marginLeft: 10, color: "#fff" }}>Bat:</strong>
                        {
                            vehicleData.type_description !== "PORTATIL" ?
                                <strong style={{
                                    marginLeft: 5, color: vehicleData.extPower <= 10 ? '#f00'
                                        : vehicleData.extPower <= 11.5 ? "#FFD700"
                                            : "#fff"
                                }}
                                >
                                    {vehicleData.extPower} V
                                </strong>
                                :
                                <strong style={{
                                    marginLeft: 5, color: vehicleData.extPower <= 3 ? '#f00'
                                        : vehicleData.extPower <= 3.5 ? "#FFD700"
                                            : "#fff"
                                }}
                                >
                                    {vehicleData.extPower} V
                                </strong>
                        }
                    </ListGroup.Item>
                    <ListGroup.Item style={{ justifyContent: 'center', backgroundColor: '#333' }}>
                        {
                            vehicleData.type !== "NEW" &&
                            <SiGitconnected
                                title={alive ? 'Online' : 'Offline'}
                                style={{ marginLeft: 5, fontSize: 20, color: alive ? "#00BFFF" : "#f00" }}
                            />
                        }

                        <MdOutlineSatelliteAlt
                            title={`${vehicleData.satelites} Satélites`}
                            style={{
                                marginLeft: 10, fontSize: 20, color: vehicleData.satelites >= 9 ? "green"
                                    : vehicleData.satelites < 8 && vehicleData.satelites > 5 ? 'yellow'
                                        : 'red'
                            }}
                        />

                        {
                            vehicleData.type_description === "PORTATIL" ?
                                (vehicleData.ignition ?
                                    <FaRunning title={'Em Movimento!'} style={{ marginLeft: 10, fontSize: 23, color: '#0f0' }} />
                                    :
                                    <FaRegStopCircle title={'Parado!'} style={{ marginLeft: 10, fontSize: 23, color: '#f00' }} />
                                )
                                :
                                (vehicleData.ignition ?
                                    <MdKey title={'Ignição Ligada!'} style={{ marginLeft: 10, fontSize: 23, color: '#0f0' }} />
                                    :
                                    <MdKeyOff title={'Ignição Desligada!'} style={{ marginLeft: 10, fontSize: 23, color: '#f00' }} />
                                )
                        }
                        {vehicleData.output2 === 1 &&
                            <>
                                <TbEngineOff title={'Veiculo Bloqueado!'} style={{ marginLeft: 10, fontSize: 23, color: '#FFD700' }} />
                            </>
                        }
                        {

                            vehicleData.type_description !== "PORTATIL" ?
                                (vehicleData.extPower <= 10.5 ?
                                    <>
                                        <FaCarBattery title={'Bateria com Tensão Baixa ou Desconectada!'} style={{ marginLeft: 10, fontSize: 23, color: '#f00' }} />
                                    </>
                                    :
                                    vehicleData.extPower <= 11.5 &&
                                    <>
                                        <FaCarBattery title={'Bateria com Tensão Baixa!'} style={{ marginLeft: 10, fontSize: 23, color: '#FFD700' }} />
                                    </>)

                                :

                                (vehicleData.extPower <= 3.0 ?
                                    <>
                                        <FaCarBattery title={'Bateria com Tensão Baixa ou Desconectada!'} style={{ marginLeft: 10, fontSize: 23, color: '#f00' }} />
                                    </>
                                    :
                                    vehicleData.extPower <= 3.5 &&
                                    <>
                                        <FaCarBattery title={'Bateria com Tensão Baixa!'} style={{ marginLeft: 10, fontSize: 23, color: '#FFD700' }} />
                                    </>)
                        }
                    </ListGroup.Item>
                    {vehicleData.type !== 'NEW' &&
                        <ListGroup.Item className="list-itens-btn">
                            <Button title={'Localização Atual!'} className="btn-action" style={{ borderBottomLeftRadius: "20px", borderTopLeftRadius: "20px", width: "40%", marginLeft: 0, marginRight: 0 }}>
                                <FaMapMarkedAlt className="icon-btn" style={{ fontSize: "20px", marginRight: "22%" }} onClick={() => OpenMap(vehicleData)} />
                            </Button>
                            <Button className="btn-action" style={{
                                borderBottomLeftRadius: "20px", borderTopLeftRadius: "20px",
                                borderBottomRightRadius: "20px", borderTopRightRadius: "20px",
                                width: "40%", marginLeft: "-20%", marginRight: 0, position: "absolute", left: "50%", zIndex: 1
                            }}>
                                <RiMapPinTimeFill title={'Posições do dia!'} onClick={() => OpenLastPositions(vehicleData)} className="icon-btn" />
                            </Button>
                            {
                                vehicleData.type_description !== "PORTATIL" && (
                                    vehicleData.pendingCommand !== null ? (
                                        <Button
                                            title={'Bloqueio/Comando Pendente!'}
                                            className="btn-action"
                                            style={{
                                                borderBottomRightRadius: "20px",
                                                borderTopRightRadius: "20px",
                                                width: "40%",
                                                marginLeft: "-10%",
                                                marginRight: 0,
                                                position: "absolute",
                                                left: "70%"
                                            }}
                                        >
                                            <TbClockExclamation className="icon-btn" style={{ fontSize: "20px", marginLeft: "25%" }} />
                                        </Button>
                                    ) : vehicleData.lastCommand === "ENABLE1" ? (
                                        <Button
                                            title={'Desativar Bloqueio?!'}
                                            style={{
                                                borderBottomRightRadius: "20px",
                                                borderTopRightRadius: "20px",
                                                width: "40%",
                                                marginLeft: "-10%",
                                                marginRight: 0,
                                                position: "absolute",
                                                left: "70%"
                                            }}
                                            onClick={() => handleOpenModalBlock("UNLOCK", vehicleData.idVehicle)}
                                            className="btn-action"
                                        >
                                            <FaLockOpen className="icon-btn" style={{ fontSize: "18px", marginLeft: "25%" }} />
                                        </Button>
                                    ) : (
                                        <Button
                                            title={'Ativar Bloqueio?!'}
                                            style={{
                                                borderBottomRightRadius: "20px",
                                                borderTopRightRadius: "20px",
                                                width: "40%",
                                                marginLeft: "-10%",
                                                marginRight: 0,
                                                position: "absolute",
                                                left: "70%"
                                            }}
                                            onClick={() => handleOpenModalBlock("LOCK", vehicleData.idVehicle)}
                                            className="btn-action"
                                        >
                                            <FaLock className="icon-btn" style={{ fontSize: "18px", marginLeft: "25%" }} />
                                        </Button>
                                    )
                                )
                            }

                        </ListGroup.Item>
                    }
                </ListGroup>
            </Card.Body>
        </Card >
    );
};

export default VehicleCard;